__turbopack_context__.v({
  "button": "collapsible-text-module-scss-module__biq01W__button",
  "button__txt": "collapsible-text-module-scss-module__biq01W__button__txt",
  "content": "collapsible-text-module-scss-module__biq01W__content",
  "description": "collapsible-text-module-scss-module__biq01W__description",
  "item": "collapsible-text-module-scss-module__biq01W__item",
  "title": "collapsible-text-module-scss-module__biq01W__title",
  "with-media": "collapsible-text-module-scss-module__biq01W__with-media",
});
